module.exports = __webpack_public_path__ + "media/images/sandbox/peach-c89c170d9ee0e53c861c886026fa8487.png";